import en from './en';

// English remains the fallback baseline; translated keys below override it.
const it = {
  ...en,
  "언어": "Lingua",
  "로그인": "Accedi",
  "로그아웃": "Esci",
  "비밀번호": "Password",
  "서버 오류": "Errore del server",
  "로그인 실패: ": "Accesso non riuscito: ",
  "🔐 어드민 로그인": "🔐 Accesso admin",
  "유저 관리": "Gestione utenti",
  "테이블 관리": "Gestione tavoli",
  "전광판": "Bacheca",
  "자산기록": "Registro asset",
  "결제관리": "Gestione pagamenti",
  "라운지 관리": "Gestione lounge",
  "공지 관리": "Gestione avvisi",
  "광고 관리": "Gestione annunci",
  "검색": "Cerca",
  "검색어를 입력하세요": "Inserisci un termine di ricerca",
  "새로고침": "Aggiorna",
  "로딩 중...": "Caricamento...",
  "로딩중...": "Caricamento...",
  "불러오는 중…": "Caricamento…",
  "불러오기 실패": "Caricamento non riuscito",
  "데이터 없음": "Nessun dato",
  "데이터가 없습니다.": "Nessun dato disponibile.",
  "표시할 기록이 없습니다.": "Nessun record da mostrare.",
  "생성": "Crea",
  "생성 중...": "Creazione...",
  "생성 중…": "Creazione…",
  "생성 실패: ": "Creazione non riuscita: ",
  "생성 에러:": "Errore di creazione:",
  "수정": "Modifica",
  "저장": "Salva",
  "저장 중...": "Salvataggio...",
  "저장 실패": "Salvataggio non riuscito",
  "삭제": "Elimina",
  "삭제 실패": "Eliminazione non riuscita",
  "삭제됨": "Eliminato",
  "취소": "Annulla",
  "닫기": "Chiudi",
  "확인": "Conferma",
  "복사": "Copia",
  "상태": "Stato",
  "상세": "Dettagli",
  "관리": "Gestisci",
  "관리 상태": "Stato admin",
  "노출": "Visibile",
  "노출중": "Visibile",
  "비활성": "Disattivato",
  "활성": "Attivo",
  "게시": "Pubblicato",
  "게시 중": "Pubblicazione",
  "게시 상태": "Stato pubblicazione",
  "만료": "Scaduto",
  "만료일:": "Scade il:",
  "게시일:": "Pubblicato il:",
  "예약": "Programmato",
  "예약 없음": "Nessuna prenotazione",
  "상시": "Sempre",
  "미리보기": "Anteprima",
  "그룹 생성": "Crea gruppo",
  "그룹 이름": "Nome gruppo",
  "그룹명": "Nome gruppo",
  "그룹 노출(DisplaySet)": "Esposizione gruppo (DisplaySet)",
  "테이블 그룹": "Gruppo tavolo",
  "테이블 생성": "Crea tavolo",
  "테이블 목록": "Lista tavoli",
  "테이블 미션": "Missione tavolo",
  "테이블 미션 설정": "Impostazioni missione tavolo",
  "Small Blind": "Small Blind",
  "Big Blind": "Big Blind",
  "Rake % (수수료율)": "Rake % (commissione)",
  "라운지 포인트 %": "Punti lounge %",
  "라운지 포인트 % (0~100)": "Punti lounge % (0–100)",
  "라운지 포인트 지급률": "Tasso punti lounge",
  "현재 라운지 포인트 %": "Punti lounge attuali %",
  "startAt (시작)": "startAt (inizio)",
  "endAt (종료, 선택)": "endAt (fine, opzionale)",
  "시작": "Inizio",
  "종료": "Fine",
  "시작(로컬)": "Inizio (locale)",
  "종료(로컬)": "Fine (locale)",
  "시작일": "Data inizio",
  "기간": "Periodo",
  "무한(30일 갱신)": "Infinito (rinnovo 30 giorni)",
  "24시간 반복": "Ripeti ogni 24 ore",
  "공지 작성/관리": "Crea/Gestisci avvisi",
  "공지 제목": "Titolo avviso",
  "공지 본문": "Corpo avviso",
  "공지 수정": "Modifica avviso",
  "새 공지 작성": "Crea nuovo avviso",
  "광고 이미지 등록/관리": "Registra/Gestisci immagine annuncio",
  "광고 수정": "Modifica annuncio",
  "새 광고 등록": "Registra nuovo annuncio",
  "광고 이미지": "Immagine annuncio",
  "라운지 글": "Post lounge",
  "라운지 글 목록": "Lista post lounge",
  "라운지 아이템": "Articolo lounge",
  "라운지 업로드": "Upload lounge",
  "라운지포인트": "Punti lounge",
  "결제 영역": "Area pagamenti",
  "결제 옵션": "Opzioni pagamento",
  "결제 옵션 추가": "Aggiungi opzione pagamento",
  "결제 완료": "Pagamento completato",
  "결제 항목": "Voce pagamento",
  "금액": "Importo",
  "수량": "Quantità",
  "미결제": "Non pagato",
  "자산": "Asset",
  "레이크백": "Rakeback",
  "일반 자산": "Asset generale",
  "라운지포인트": "Punti lounge",
  "관리자 자산 표시 영역": "Area riepilogo asset admin",
  "나의 지갑 주소": "Il mio indirizzo wallet",
  "보내는 지갑": "Wallet mittente",
  "받는 지갑": "Wallet destinatario",
  "에이전트": "Agente",
  "에이전트로 생성": "Crea come agente",
  "하위 계정 생성": "Crea account figlio",
  "하위 생성": "Crea figlio",
  "하위 {id}": "Figlio {id}",
  "소속 유저": "Utenti assegnati",
  "소속유저": "Utenti assegnati",
  "상위 에이전트:": "Agente superiore:",
  "수수료": "Commissione",
  "수수료 수정": "Modifica commissione",
  "수수료 수정 실패": "Modifica commissione non riuscita",
  "분배 비율": "Percentuale distribuzione",
  "분배 비율(상대 %)": "Percentuale distribuzione (relativa %)",
  "Country 필터": "Filtro paese",
  "Device 필터": "Filtro dispositivo",
  "동아시아": "Asia orientale",
  "동남아": "Sud-est asiatico",
  "유럽": "Europa",
  "북미": "Nord America",
  "남미": "Sud America",
  "아프리카": "Africa",
  "글로벌": "Globale",
  "제목": "Titolo",
  "본문": "Corpo",
  "내용(message)": "Contenuto (messaggio)",
  "이미지": "Immagine",
  "이미지 URL": "URL immagine",
  "업로드": "Carica",
  "업로드중...": "Caricamento...",
  "링크 열기": "Apri link",
  "링크:": "Link:",
  "인포카드": "Scheda info",
  "하이라이트 포인트": "Punto evidenziato",
  "하이라이트 메세지": "Messaggio evidenziato",
  "프리셋 수정": "Modifica preset",
  "배경 색상": "Colore sfondo",
  "배경 이미지 URL": "URL immagine sfondo",
  "배경 타입": "Tipo sfondo",
  "폰트스타일": "Stile font",
  "굵기": "Peso",
  "색상": "Colore",
  "표시명": "Nome visualizzato",
  "페이지": "Pagina",
  "페이지 크기": "Dimensione pagina",
  "다음": "Avanti",
  "이전": "Indietro",
  "위로": "Su",
  "아래로": "Giù",
  "펼치기": "Espandi",
  "개": "pz",
  "건": "record",
  "명": "utenti",
  "⚠️ 권한이 없습니다": "⚠️ Nessuna autorizzazione",
  "이 페이지에 접근할 수 있는 권한이 없습니다.": "Non hai il permesso di accedere a questa pagina.",
};

export default it;
